import withMiddlewares from "@/middlewares/withMiddlewares";
import SignupForm from "@/components/Form/SignupForm";
import routes from "@/lib/routes";

import ViewingArticle from "@/lib/ViewingArticle";
import processStyles from "@/styles/Process.module.scss";

import { useRequireIdcLogin } from "@/hooks";

export default function SignUp() {
  // useRequireLogout(); // 利用登録APIでログイン済みになると利用登録完了ページに遷移する前にこれが反応してトップページに飛んでしまうので使えない
  useRequireIdcLogin();

  return (
    <>
      <div className={processStyles.container}>
        <div className={processStyles.inner}>
          <h2>スカパー！動画ストア利用登録</h2>
          <div>
            <SignupForm />
          </div>
        </div>
      </div>
    </>
  );
}
SignUp.layout = "NoHeaderLayout";

export const getServerSideProps = withMiddlewares(
  async ({ req, res, query }, { serverProps, error, apolloClient }) => {
    if (req.userToken) {
      return {
        redirect: {
          permanent: false,
          destination: routes.home,
        },
      };
    }

    return {
      props: {
        ...serverProps,
        error,
        initialApolloState: apolloClient.cache.extract(),
      },
    };
  }
);
